// extracted by mini-css-extract-plugin
module.exports = {"noShippingPrice":"_638c3b4e"};